import { splitDeceasedName } from '@shared/api/fevent/deceasedName.util';
import { DeathCharacter } from '@shared/miscValues';
import { Gender } from '@shared/types';

export const deceasedNameString = (
  name: string,
  sex?: Gender,
  age?: number,
  nameDetail?: string,
) => {
  //* name은 "홍길동 어거스틴" 합성값일 수 있어 분리해서 한 번만 표기
  const { baseName, extraName } = splitDeceasedName({ name, nameDetail });
  const stringElement = [
    DeathCharacter,
    baseName,
    extraName && '(' + extraName + ')',
    (sex || age) &&
      '(' + (sex ? sex : '') + (sex && age ? '/' : '') + (age ? age + '세' : '') + ')',
  ];

  return stringElement.join(' ');
};
